"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateQueryString = exports.CustomError = exports.Service = exports.CompanyService = exports.RegionService = exports.MerchantResponsibleService = exports.WalletService = exports.EntryService = exports.BarterProductService = exports.PriceAlertService = exports.FreightQuoteService = exports.CityService = exports.MarketDataService = exports.NegotiationService = exports.LeadService = exports.BidService = exports.AccountService = void 0;
var services = __importStar(require("./services"));
var Account_service_1 = require("./services/Account.service");
Object.defineProperty(exports, "AccountService", { enumerable: true, get: function () { return __importDefault(Account_service_1).default; } });
var Bid_service_1 = require("./services/Bid.service");
Object.defineProperty(exports, "BidService", { enumerable: true, get: function () { return __importDefault(Bid_service_1).default; } });
var Lead_service_1 = require("./services/Lead.service");
Object.defineProperty(exports, "LeadService", { enumerable: true, get: function () { return __importDefault(Lead_service_1).default; } });
var Negotiation_service_1 = require("./services/Negotiation.service");
Object.defineProperty(exports, "NegotiationService", { enumerable: true, get: function () { return __importDefault(Negotiation_service_1).default; } });
var MarketData_service_1 = require("./services/MarketData.service");
Object.defineProperty(exports, "MarketDataService", { enumerable: true, get: function () { return __importDefault(MarketData_service_1).default; } });
var City_service_1 = require("./services/City.service");
Object.defineProperty(exports, "CityService", { enumerable: true, get: function () { return __importDefault(City_service_1).default; } });
var FreightQuote_service_1 = require("./services/FreightQuote.service");
Object.defineProperty(exports, "FreightQuoteService", { enumerable: true, get: function () { return __importDefault(FreightQuote_service_1).default; } });
var PriceAlert_service_1 = require("./services/PriceAlert.service");
Object.defineProperty(exports, "PriceAlertService", { enumerable: true, get: function () { return __importDefault(PriceAlert_service_1).default; } });
var Barter_service_1 = require("./services/Barter.service");
Object.defineProperty(exports, "BarterProductService", { enumerable: true, get: function () { return __importDefault(Barter_service_1).default; } });
var Entry_service_1 = require("./services/Entry.service");
Object.defineProperty(exports, "EntryService", { enumerable: true, get: function () { return __importDefault(Entry_service_1).default; } });
var Wallet_service_1 = require("./services/Wallet.service");
Object.defineProperty(exports, "WalletService", { enumerable: true, get: function () { return __importDefault(Wallet_service_1).default; } });
var MerchantResponsible_service_1 = require("./services/MerchantResponsible.service");
Object.defineProperty(exports, "MerchantResponsibleService", { enumerable: true, get: function () { return __importDefault(MerchantResponsible_service_1).default; } });
var Region_service_1 = require("./services/Region.service");
Object.defineProperty(exports, "RegionService", { enumerable: true, get: function () { return __importDefault(Region_service_1).default; } });
var Company_service_1 = require("./services/Company.service");
Object.defineProperty(exports, "CompanyService", { enumerable: true, get: function () { return __importDefault(Company_service_1).default; } });
var Service_1 = require("./Service");
Object.defineProperty(exports, "Service", { enumerable: true, get: function () { return __importDefault(Service_1).default; } });
var CustomError_1 = require("./CustomError");
Object.defineProperty(exports, "CustomError", { enumerable: true, get: function () { return __importDefault(CustomError_1).default; } });
var generateQueryString_1 = require("./utils/generateQueryString");
Object.defineProperty(exports, "generateQueryString", { enumerable: true, get: function () { return __importDefault(generateQueryString_1).default; } });
__exportStar(require("./@types"), exports);
exports.default = { services: services };
